import { PartnerAddWizard } from '@features/ForestOwner/EditShareOwnership/Partner/PartnerAddWizard'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'

export const Route = createFileRoute(
  '/forestowner/$forestownerId/shareownership/editShareOwnership/partner/add/',
)({
  component: () => <PartnerAddWizard />,
  staticData: {
    breadcrumb: t('forestowner-editshareownership-partner.cta'),
  },
})
